import React, {useState, useCallback} from "react"
import Button from "@amzn/meridian/button"
import Icon from "@amzn/meridian/icon"
import filterTokens from "@amzn/meridian-tokens/base/icon/filter"
import Column from "@amzn/meridian/column"
import Theme from "@amzn/meridian/theme";
export const FilterExpander = ({children}) => {
    const [open, setOpen] = useState(false)
    const onClick = useCallback(() => {setOpen(!open)}, [open])

    const FilterButton = () => (
        <Theme tokens={{
            buttonSpacingInsetHorizontalMedium: 5,
        }}>
            <Button
                onClick={onClick} type="link" size="medium" >
                <Icon tokens={filterTokens} /> Filters
            </Button>
        </Theme>
    )
    return (
        <Column alignmentHorizontal={"left"} >
            <FilterButton />
            {open ? children : null}
        </Column>

    )
}


// WEBPACK FOOTER //
// ./src/components/common/FilterExpander.js